export const translations = {
  en: {
    recommendation: {
      analyzingPatientInfo: 'Analyzing patient information...',
      careGapOutreachRecommendationTitle: 'Mammogram',
      careGapOutreachRecommendationDescription:
        'Based on your records, you are due for a mammogram. Please schedule one today.',
      careGapOutreachRecommendationCallToActionText: 'Schedule appointment',
      diabetesRecommendationTitle: 'Join a health program',
      diabetesRecommendationDescription:
        'You would be a great candidate to join our Omada Health Program.',
      diabetesRecommendationCallToActionText: 'Learn More',
      helixRecommendationTitle: 'New research study',
      helixRecommendationDescription:
        'Based on your records, you qualify to enroll in a research project at MUSC.',
      helixRecommendationCallToActionText: 'Learn More',
      foundOpportunity:
        'We found {{count}} new opportunity to improve your health!',
      foundOpportunity_plural:
        'We found {{count}} new opportunities to improve your health!',
      lookingForCareOpportunities: 'Looking for care opportunities...',
      submittingYourRegistration: 'Submitting your registration...',
    },
  },
  es: {
    recommendation: {
      analyzingPatientInfo: 'Analizando la información del paciente...',
      foundOpportunity:
        'Encontramos {{count}} nueva oportunidad para mejorar tu salud!',
      foundOpportunity_plural:
        'Encontramos {{count}} nuevas oportunidades para mejorar tu salud!',
      lookingForCareOpportunities: 'Buscando oportunidades de atención...',
      submittingYourRegistration: 'Enviando su registro...',
      careGapOutreachRecommendationCallToActionText: 'Programar cita',
    },
  },
};
